var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaveConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 38,
    viewBox: "0 0 54 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_885_28076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.37046 16.6117L12.7371 11.7116C13.6346 11.1147 14.8463 11.3352 15.4256 12.2441C16.8218 14.4346 17.9748 16.6755 18.8846 18.1885C20.2048 20.3839 21.0807 21.7246 23.1541 20.9407C23.3338 20.8727 23.4974 20.7668 23.6437 20.6422L46.6592 1.05539C48.4984 -0.509789 50.5717 1.54998 48.988 3.37325C39.8441 13.9007 29.2621 25.757 26.8269 27.9998C22.8936 31.6224 18.1282 29.5092 16.2372 27.9998L5.28721 19.8838C4.17406 19.0587 4.21679 17.3791 5.37046 16.6117Z",
    fill: "url(#paint0_linear_885_28076)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_885_28076",
    x: 0.478027,
    y: 0.500977,
    width: 53.0728,
    height: 37.499,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_885_28076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_885_28076",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_885_28076",
    x1: 7,
    y1: 15.5,
    x2: 52,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89F1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DA6AC"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaveConfirm);
export default __webpack_public_path__ + "static/media/cave-confirm.713bba42325f66b549782ce1318abb47.svg";
export { ForwardRef as ReactComponent };